import { Modal } from 'antd'
import {
  getDownloadResult,
  putPedlaboratorioResultado,
  reprocessarOs,
} from '../../../../../../services/Laboratorio'
import { destroyAlert, errorAlert, infoAlert, loadingAlert, successAlert } from '../../../../../../utils/alert'
import { UploadChangeParam } from 'antd/lib/upload'
import { CSVToJSON, fileTypeText, tryError } from '../../../../../../services/Afins'
import fileBase64 from '../../../../../../Components/Base64Geral'
import { TypeGetOs } from '../../../../../../services/Laboratorio/GET'
import { dados_status } from '../tabela/components/statusTimeLine/meta'
import {
  faCheckCircle,
  faFolderOpen,
  faList,
  faLockOpen,
  faPaperPlane,
  faSearch,
  faSeedling,
} from '@fortawesome/free-solid-svg-icons'
import shp from 'shpjs'
import { getLabAnalise } from '../../../../../../services/LabAnalises'
import dayjs from 'dayjs'
import { LabAnaliseItens } from '../../../../../../services/LabAnalise'
import { GeoPointFeature } from '../formulario/components/análises/components/headerAnalises/components/modalNovaAnalise'

export interface AmostraData {
  id: string
  numero: string
  nome: string
  endereco: string
  propriedade: string
  gleba: string
  mg: number
  aluminio: number
  hal: number
  sb: number
  ctc: number
  al_pct: number
  mg_pct: number
  ca_k: number
  mg_k: number
  ferro: number
  manganes: number
  bases_v: number
  percent_ca: number
  percent_k: number
  boro: number
  p: number
  p_rem: number
  ph_cacl2: number
  cobre: number
  zinco: number
  enxofre: number
  teor_argila: number
  teor_silte: number
  mo: number
}

type campos = {
  data_osColeta_editar: TypeGetOs
  listTalhoes: any[]
  setStatus_atual: React.Dispatch<React.SetStateAction<string>>
  setStatus_atual_id: React.Dispatch<React.SetStateAction<number>>
  setData_da_os: React.Dispatch<React.SetStateAction<string>>
  setOutros_solicitantes: React.Dispatch<React.SetStateAction<string>>
  setPropriedade: React.Dispatch<React.SetStateAction<string>>
  setPropriedade_id: React.Dispatch<React.SetStateAction<number>>
  setTalhao: React.Dispatch<React.SetStateAction<string>>
  setTalhao_id: React.Dispatch<React.SetStateAction<number>>
  setLaboratorio: React.Dispatch<React.SetStateAction<string>>
  setLaboratorio_id: React.Dispatch<React.SetStateAction<number>>
  setSafra_consultoria: React.Dispatch<React.SetStateAction<string>>
  setSafra_consultoria_id: React.Dispatch<React.SetStateAction<number>>
  setArea_amostra_laudo: React.Dispatch<React.SetStateAction<string>>
  setResponsaveis_selecionados: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  setColeta_liberada: React.Dispatch<React.SetStateAction<string>>
  setColetado_em: React.Dispatch<React.SetStateAction<string>>
  setOpen_loading_analise_lab: React.Dispatch<React.SetStateAction<boolean>>
  setGrupoAnalises: React.Dispatch<React.SetStateAction<LabAnaliseItens[]>>
  setAnalises: React.Dispatch<
    React.SetStateAction<
      {
        id?: string | number
        cod_analise: number
        cor: string
        pontos_selecionados: GeoPointFeature[]
        profundidade: string
        analise_nome: string
        valor: string
        valor_analise: string
      }[]
    >
  >
  setMalha: React.Dispatch<React.SetStateAction<any[]>>
  setMalhaShp: React.Dispatch<React.SetStateAction<any[]>>
  setPontosTotalMalha: React.Dispatch<React.SetStateAction<number>>
  setTalhaoKml: React.Dispatch<React.SetStateAction<any[]>>
}

function fraseReprocessar(cod_calcario, cod_propriedade, nome, talhao) {
  if (cod_calcario !== cod_propriedade) {
    return 'O calcário atual é diferente do processado, deseja realmente reprocessar a OS?'
  } else {
    return `Deseja reprocessar a OS da ${nome} - ${talhao}?`
  }
}

export async function handleDownloadResultado(url, link) {
  if (url) {
    const response = await getDownloadResult(url)

    // @ts-ignore
    const newLink = URL.createObjectURL(response.data)

    link.href = newLink
    link.click()
  } else {
    errorAlert(
      'Não encontramos arquivos processados. Faça o upload de um arquivo para prosseguir',
      5000
    )
  }
}

export async function handleReprocessarOs(
  cod,
  cod_cliente,
  nome,
  talhao,
  codCalcario,
  codCalcarioPropriede
) {
  Modal.confirm({
    title: fraseReprocessar(codCalcario, codCalcarioPropriede, nome, talhao),
    okText: 'Sim',
    cancelText: 'Não',

    cancelButtonProps: {
      type: 'primary',
      danger: true,
    },
    onOk: async () => {
      try {
        loadingAlert({ msg: 'Reprocessando OS...', id: 'proce_os' })
        const response = await reprocessarOs(cod, cod_cliente)

        if (response.status === 200) {
          successAlert('OS reprocessada com sucesso!', 5000, 'proce_os')
          Modal.destroyAll()
        }
      } catch (error) {
        Modal.error({
          title: 'Erro',
          content: 'Ocorreu um erro ao reprocessar a OS.',
        })
        destroyAlert('proce_os')
      }
    },
  })
}

const parseRawNumber = (value: string | undefined): number => {
  if (!value) return 0

  const cleanStr = value.trim().toLowerCase()

  if (cleanStr === 'ns' || cleanStr === '-' || cleanStr === '') return 0

  let numberStr = cleanStr.replace(',', '.')
  const number = parseFloat(numberStr)

  return isNaN(number) ? 0 : number
}

export const parseCustomCsv = (csvText: string): AmostraData[] => {
  const lines = csvText?.split(/\r\n|\n/)
  const dataLines = lines.slice(1).filter((line) => line.trim().length > 0)

  return dataLines.map((line, index) => {
    const cols = line.split(';')

    return {
      id: String(index + 1),
      numero: cols[0] || '',
      nome: cols[1] || '',
      endereco: cols[2] || '',
      propriedade: cols[3] || '',
      gleba: cols[4] || '',
      ph_cacl2: parseRawNumber(cols[5]),
      mo: parseRawNumber(cols[6]),
      p: parseRawNumber(cols[7]),
      p_rem: parseRawNumber(cols[8]),
      mg: parseRawNumber(cols[11]),
      aluminio: parseRawNumber(cols[12]),
      hal: parseRawNumber(cols[13]),
      sb: parseRawNumber(cols[14]),
      ctc: parseRawNumber(cols[15]),
      bases_v: parseRawNumber(cols[16]),
      al_pct: parseRawNumber(cols[17]),
      percent_ca: parseRawNumber(cols[18]),
      mg_pct: parseRawNumber(cols[19]),
      percent_k: parseRawNumber(cols[20]),
      ca_k: parseRawNumber(cols[22]),
      mg_k: parseRawNumber(cols[23]),
      ferro: parseRawNumber(cols[24]),
      manganes: parseRawNumber(cols[25]),
      cobre: parseRawNumber(cols[26]),
      zinco: parseRawNumber(cols[27]),
      boro: parseRawNumber(cols[28]),
      enxofre: parseRawNumber(cols[29]),
      teor_argila: parseRawNumber(cols[30]),
      teor_silte: parseRawNumber(cols[31]),
    }
  })
}

function filtrarGrupoAnalise(cod, grupoAnalises: LabAnaliseItens[]) {
  const grupoAnaliseFilter = grupoAnalises?.filter((item) => item?.cod_analise === cod)
  return grupoAnaliseFilter[0]?.cor
}

function adicionarCorPontos(pontos, cor) {
  const dadosComCor = pontos.map((item) => ({
    ...item,
    COR: cor, // ou qualquer valor que quiser
  }))
  return dadosComCor
}

export function PreencherDados(campos: campos) {
  const {
    data_osColeta_editar,
    listTalhoes,
    setArea_amostra_laudo,
    setColeta_liberada,
    setColetado_em,
    setData_da_os,
    setLaboratorio,
    setLaboratorio_id,
    setOutros_solicitantes,
    setPropriedade,
    setPropriedade_id,
    setResponsaveis_selecionados,
    setSafra_consultoria,
    setSafra_consultoria_id,
    setStatus_atual,
    setStatus_atual_id,
    setTalhao,
    setTalhao_id,
    setOpen_loading_analise_lab,
    setGrupoAnalises,
    setAnalises,
    setMalha,
    setMalhaShp,
    setPontosTotalMalha,
    setTalhaoKml
  } = campos
  setStatus_atual(
    dados_status?.filter((item) => item?.cod === data_osColeta_editar?.itens[0]?.status)[0]?.nome
  )
  const talhaoFilter = listTalhoes?.filter(item => item?.nome === data_osColeta_editar?.itens[0]?.talhao_nome)
  setStatus_atual_id(dados_status[0]?.cod)
  setOutros_solicitantes(data_osColeta_editar?.itens[0]?.solicitante)
  setTalhao(talhaoFilter[0]?.nome)
  setTalhao_id(talhaoFilter[0]?.cod)
  setLaboratorio(data_osColeta_editar?.itens[0]?.laboratorio_nome)
  setLaboratorio_id(data_osColeta_editar?.itens[0]?.cod_laboratorio)
  buscarAnalisesPorLabEditar(
    data_osColeta_editar?.itens[0]?.cod_laboratorio,
    setOpen_loading_analise_lab,
    data_osColeta_editar?.itens[0]?.data,
    setGrupoAnalises
  )
  setPropriedade(data_osColeta_editar?.itens[0]?.propriedade_nome)
  setPropriedade_id(data_osColeta_editar?.itens[0]?.cod_propriedade)
  setResponsaveis_selecionados(
    data_osColeta_editar?.itens[0]?.responsaveis.map((item) => {
      return {
        descr: item?.responsavel_nome,
        id: item?.cod_responsavel,
        key: item?.cod_responsavel,
      }
    })
  )
  const safeDate = (date: any) => {
    if (!date) return ''
    const d = dayjs(date)
    return d.isValid() ? String(date) : ''
  }

  setArea_amostra_laudo(
    String(data_osColeta_editar?.itens[0]?.cod_area_amostra === 50 ? '50 ha' : '20 ha')
  )
  setData_da_os(safeDate(data_osColeta_editar?.itens[0]?.data))
  setColeta_liberada(safeDate(data_osColeta_editar?.itens[0]?.data_liberada))
  setColetado_em(safeDate(data_osColeta_editar?.itens[0]?.data_coleta))
  setSafra_consultoria(data_osColeta_editar?.itens[0]?.safra_consultoria_nome)
  setSafra_consultoria_id(data_osColeta_editar?.itens[0]?.cod_safra_conta)
  setTalhaoKml(data_osColeta_editar?.itens[0]?.talhao_kml?.coordenadas)
  setTimeout(() => {
    const analiseTratada = data_osColeta_editar?.itens[0]?.analises.map((item) => {
      
      return {
        id: item?.id || Date.now(),
        cod_analise: Number(item?.cod_analises[0]?.cod),
        pontos_selecionados: adicionarCorPontos(
          item?.pontos,
           item?.cod_analises[0]?.cor
        ),
        profundidade: item?.profundidade,
        analise_nome: item?.cod_analises[0]?.nome,
        valor: item?.cod_analises[0]?.valor,
        cor: item?.cod_analises[0]?.cor,
        valor_analise: (Number(item?.cod_analises[0]?.valor) * item?.pontos?.length).toLocaleString(
          'pt-br',
          {
            style: 'currency',
            currency: 'BRL',
          }
        ),
      }
    })

    setAnalises(analiseTratada)
  }, 400)
  //@ts-ignore
  setMalhaShp(data_osColeta_editar?.itens[0]?.malha_de_pontos)
  setPontosTotalMalha(data_osColeta_editar?.itens[0]?.malha_de_pontos?.features?.length)
  setMalha(
    data_osColeta_editar?.itens[0]?.malha_de_pontos?.features.map((data) => {
      //@ts-ignore
      if (data.properties.NOME === undefined && data.properties.AUTO_ID === undefined) {
        throw new Error('Arquivo Invalido')
      }

      let lat, long
      //@ts-ignore
      if (data.geometry.type === 'Point') {
        //@ts-ignore
        ;[long, lat] = data.geometry.coordinates
      } else {
        //@ts-ignore
        const centro = getCentroid(data.geometry.coordinates)
        lat = centro.lat
        long = centro.lng
      }

      return {
        //@ts-ignore
        INDICE: data.properties.INDICE || data.properties.AUTO_ID,
        //@ts-ignore
        NOME: parseInt(data.properties.NOME, 10) || parseInt(data.properties.AUTO_ID, 10),
        LATITUDE: lat,
        LONGITUDE: long,
      }
    })
  )
}

export const statusIcones = {
  ABERTA: faFolderOpen,
  LIBERADA: faLockOpen,
  COLETADA: faSeedling,
  'ENVIADO PARA ANÁLISE': faPaperPlane,
  'EM ANÁLISE': faSearch,
  ANALISADA: faCheckCircle,
  '': faList,
}

//UPLOAD DOS ARQUIVOS
export const handleUploadResult = async (
  info: UploadChangeParam,
  cod: number,
  setResultAnalise,
  setTextCSV,
  setAbrirPreviewFile
) => {
  if (info.file.status === 'done') {
    loadingAlert({ msg: 'Carregando...', id: 'upload' })
    const csv = info.file.originFileObj

    const texCsv = await fileTypeText(csv)
    const formatadoTxt = parseCustomCsv(texCsv)

    const base64 = await fileBase64(csv)

    setTextCSV(formatadoTxt)

    setResultAnalise({ base64, cod })

    setAbrirPreviewFile(true)
    destroyAlert('upload')
  }
}

export const dumpRequest = (options) => {
  const { onSuccess } = options

  setTimeout(() => {
    onSuccess('done')
  }, 500)
}

export const handleEnviarFile = async (resultAnalise, listarOrdensServico, setDrawerFilePrevia) => {
  try {
    loadingAlert({ msg: 'Enviando resultado...', id: 'resultado' })
    const response = await putPedlaboratorioResultado(resultAnalise.cod, resultAnalise.base64)

    if (response.status === 200) {
      successAlert('Resultado enviado com sucesso!', 5000, 'resultado')
      listarOrdensServico()
      setDrawerFilePrevia(false)
    }
  } catch (error) {
    if (error.response) {
      const { data } = error.response
      if (!data.error[0]?.field) {
        errorAlert(data?.error ?? 'Falha na operação', 5000, 'resultado')
      } else {
        data.error.forEach((data) => {
          errorAlert(data?.msg?.[0] ?? 'Falha na operação', 5000, 'resultado')
        })
      }
    } else {
      errorAlert('Falha ao enviar resultado!', 5000, 'resultado')
    }
  }
}

/*ANALISES */

function getCentroid(coords) {
  let totalLat = 0
  let totalLng = 0
  let count = 0

  const processCoords = (arr) => {
    if (typeof arr[0] === 'number') {
      totalLng += arr[0]
      totalLat += arr[1]
      count++
    } else {
      arr.forEach(processCoords)
    }
  }

  processCoords(coords)

  return {
    lat: count > 0 ? totalLat / count : 0,
    lng: count > 0 ? totalLng / count : 0,
  }
}

//IMPORTAR MALHA GERAL
export async function importarMalhaGeral(
  files: File[],
  setLoadingShape,
  setMalha,
  setMalhaShp,
  setPontosTotalMalha
) {
  if (!files || files.length === 0) return

  try {
    setLoadingShape(true)

    let newFile = await files[0].arrayBuffer()
    const geojson = await shp(newFile)

    // @ts-ignore
    const malhaShape = geojson.features.map((data) => {
      // Validação
      if (data.properties.NOME === undefined && data.properties.AUTO_ID === undefined) {
        setMalhaShp([])
        setLoadingShape(false)
        throw new Error('Arquivo Invalido')
      }

      // Modificações
      data.color = '#ffffff'
      data.properties.NOME =
        parseInt(data.properties.NOME, 10) || parseInt(data.properties.AUTO_ID, 10)

      return data
    })
    // @ts-ignore
    const novaMalha = geojson.features.map((data) => {
      if (data.properties.NOME === undefined && data.properties.AUTO_ID === undefined) {
        throw new Error('Arquivo Invalido')
      }

      let lat, long
      if (data.geometry.type === 'Point') {
        ;[long, lat] = data.geometry.coordinates
      } else {
        const centro = getCentroid(data.geometry.coordinates)
        lat = centro.lat
        long = centro.lng
      }

      return {
        INDICE: data.properties.INDICE || data.properties.AUTO_ID,
        NOME: parseInt(data.properties.NOME, 10) || parseInt(data.properties.AUTO_ID, 10),
        LATITUDE: lat,
        LONGITUDE: long,
      }
    })

    const malhaShapeProcessada = {
      features: malhaShape,
      fileName: 'POINT',
      type: 'FeatureCollection',
    }
    setMalhaShp(malhaShapeProcessada)
    setMalha(novaMalha)
    //@ts-ignore
    setPontosTotalMalha(novaMalha?.length)
    setLoadingShape(false)
  } catch (error) {
    console.error(error)
    setLoadingShape(false)
  }
}

async function buscarAnalisesPorLabEditar(
  cod,
  setOpen_loading_analise_lab,
  data_vigencia,
  setGrupoAnalises
) {
  setOpen_loading_analise_lab(true)
  const analiseLab = await getLabAnalise('', cod, data_vigencia)
  // @ts-ignore
  setGrupoAnalises(analiseLab.data.itens)

  setTimeout(() => {
    setOpen_loading_analise_lab(false)
  }, 2000)
}

export async function buscarAnalisesPorLab(
  cod,
  update,
  setLaboratorio_id,
  setOpen_loading_analise_lab,
  data_vigencia,
  setGrupoAnalises,
  setAnalises_nao_encontradas,
  setValores_analises_editados,
  setOpen_modal_confirm_lab,
  analises,
  setAnalises

) {
  setLaboratorio_id(cod)
  setOpen_loading_analise_lab(true)
  const analiseLab = await getLabAnalise('', cod, data_vigencia)
  // @ts-ignore
  setGrupoAnalises(analiseLab.data.itens)

  // setListFornServico(analiseLab.data.itens)

  //se estiver editando
  if (update) {
    let analise_atual = analises
    let info_laboratorio = analiseLab?.data?.itens ?? []
    if ((analiseLab.data.itens ?? []).length === 0) {
      infoAlert('Laboratório selecionado não possui análises cadastradas!')
    }

    let atualizar_valor_analises = analise_atual.map((item) => {
      let analise_por_profundidade = info_laboratorio.filter(
        (i: any) => i.profundidade_nome === item.profundidade
      )
      let analise_por_nome = analise_por_profundidade.filter(
        (i) => i.analise_nome?.toLowerCase() === item.cod_analises?.[0]?.nome?.toLowerCase()
      )
      let novo_valor = analise_por_nome.length > 0 ? analise_por_nome?.[0]?.valor : 0

      return {
        ...item,
        analise_encontrada_no_lab: (analise_por_nome ?? []).length > 0,
        cod_analises: (item?.cod_analises ?? []).map((sub_item) => ({
          ...sub_item,
          valor: novo_valor,
        })),
      }
    })

    let nao_encontradas = atualizar_valor_analises.filter((i) => !i.analise_encontrada_no_lab)
    let apenas_encontradas = atualizar_valor_analises.filter((i) => i.analise_encontrada_no_lab)

    setOpen_loading_analise_lab(false)

    if (nao_encontradas.length > 0) {
      setAnalises_nao_encontradas(nao_encontradas)
      setValores_analises_editados(apenas_encontradas)

      setOpen_modal_confirm_lab(true)
      return
    }

    setAnalises(apenas_encontradas)
  }

  setTimeout(() => {
    setOpen_loading_analise_lab(false)
  }, 2000)
}

export function calcularPorcentagem(adicionados, total) {
  if (total === 0) {
    return 0
  }

  const resultado = (adicionados / total) * 100
  return `(${resultado.toFixed(2)}%)` // Retorna string com 2 casas decimais
}

export function converteKmlBase64(talhaoKml: any[]) {
  if (Array.isArray(talhaoKml) && talhaoKml.length > 0) {
    const coordinates = talhaoKml.map((coord) => `${coord.lng},${coord.lat},0`).join(' ')
    const kmlContent = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <Placemark>
      <Polygon>
        <outerBoundaryIs>
          <LinearRing>
            <coordinates>
              ${coordinates}
            </coordinates>
          </LinearRing>
        </outerBoundaryIs>
      </Polygon>
    </Placemark>
  </Document>
</kml>`

    return `data:@file/xml;base64,${btoa(kmlContent)}`
  }
  return talhaoKml
}
